export default {
  TARGET_ACTIVATION: {
    TITLE_EMAIL_HINT: 'This title will be displayed to users in the invitation email.',
    EDIT: 'Edit targeting',
    NAME: 'Targeting name',
    START: 'Start date and time',
    END: 'End date and time',
    SHARE: 'Share link',
    CLOSE: 'Close targeting',
    STATUS: 'Status',
    STATUS_SCHEDULED: 'Upcoming',
    STATUS_ACTIVE: 'In progress',
    STATUS_ENDED: 'Ended',
    STATUS_CLOSED: 'Closed',
    STATUS_UNKNOWN: 'Status unavailable',
    PARTICIPATION: 'Participation',
    RESPONSES_RECEIVED: 'Responses received',
    TARGETED_COUNT: '{{count}} targeted people',
    TARGETED_ONE: '1 targeted person',
    PARTICIPATION_SUMMARY: '{{received}} responses received for {{targeted}} targeted people.',
    PARTICIPATION_HINT: 'The rate is estimated from submissions received and the currently targeted population. Anonymous submissions or population changes may affect this ratio. Without a targeted population, the rate is unavailable.',
    NAME_REQUIRED: 'Enter a targeting name between 1 and 255 characters.',
    DATES_INVALID: 'Enter valid dates, with the end strictly after the start.',
    PERIOD_HINT: 'Changing dates changes the access period. Extending expired targeting may make it accessible again.',
    CLOSED_HINT: 'Manually closed targeting will remain closed after this update.',
    UPDATE_SUCCESS: 'Targeting was updated.',
    UPDATE_ERROR: 'Unable to update targeting. Please try again.',
    ERROR_FORBIDDEN: 'You do not have permission to edit this targeting.',
    ERROR_NOT_FOUND: 'This targeting could not be found or is no longer available.',
    ERROR_NOT_EDITABLE: 'This targeting is managed by onboarding and cannot be edited here.',
  },
  RESULTS: {
    TITLE: 'Results',
    DISPLAY_MODES: {
      PERCENTAGE: 'Percentage',
      NUMBERS: 'Numerical',
      AVERAGE: 'Average',
    },
    FILTERS: {
      TITLE: 'Filters',
      ALL: 'All',
      RESET: 'Reset',
      GENDER: 'Gender',
      CONTRACT_TYPE: 'Contract type',
      AGE_RANGE: 'Age range',
      SENIORITY: 'Seniority',
      // Label for the chart-specific multi-select displayed above the transverse-team chart.
      TRANSVERSE_TEAMS: 'Transverse teams',
      // Compact summaries match the wording and density of the existing select filters.
      ALL_TRANSVERSE_TEAMS: 'All',
      NO_TRANSVERSE_TEAM: 'None',
      TRANSVERSE_TEAMS_COUNT: '{{count}} teams',
      GENDER_MALE: 'Male',
      GENDER_FEMALE: 'Female',
      GENDER_OTHER: 'Other',
      UNKNOWN_OPTION: 'Unknown / not provided',
      UNKNOWN_HINT: 'Unknown values are available under “Unknown / not provided”.',
      HIDE_SMALL_TEAMS: 'Hide teams < 5 responses',
      HIDE_SMALL_TEAMS_HINT: 'Hides teams with fewer than 5 responses',
    },
    CHARTS: {
      BY_SITE: 'Distribution by site',
      BY_SERVICE: 'Distribution by service',
      BY_TEAM: 'Distribution by team',
      BY_TRANSVERSE_TEAM: 'Distribution by transverse team',
      AVERAGE: 'Average',
    },
    AI_VISUAL: {
      BUTTON: 'Generate AI visual',
      TITLE: 'AI visual generation',
      PROMPT_LABEL: 'Describe the visual you want',
      PROMPT_PLACEHOLDER: 'Example: Create a clear A4 summary with key indicators, main risks and priority actions.',
      SCOPE_LABEL: 'Data scope',
      SCOPE_CURRENT_FILTERS: 'Current filters',
      SCOPE_FULL_TARGET: 'Full target',
      REFERENCE_IMAGE: 'Style or reference image (optional)',
      ANALYZE_REFERENCE: 'Analyze',
      REFERENCE_ANALYSIS_TITLE: 'What AI understands from the image',
      ANALYZING_REFERENCE: 'Analyzing image...',
      REFERENCE_ANALYSIS_SUMMARY: 'Summary',
      REFERENCE_ANALYSIS_MOTIF: 'Structure',
      REFERENCE_ANALYSIS_SHAPE: 'Shape',
      REFERENCE_ANALYSIS_PRIMARY_VISUAL: 'Primary visual',
      REFERENCE_ANALYSIS_COMPOSITION: 'Composition',
      REFERENCE_ANALYSIS_STYLE: 'Style',
      REFERENCE_ANALYSIS_CONFIDENCE: 'Confidence',
      REFERENCE_ANALYSIS_CUES: 'Detected visual details',
      REFERENCE_ANALYSIS_ERROR: 'Unable to analyze the reference image.',
      CLEAR_FILE: 'Remove',
      HISTORY: 'History',
      HIDE_HISTORY: 'Hide history',
      SHOW_HISTORY: 'Show history',
      REFRESH: 'Refresh',
      NO_HISTORY: 'No visual generated for this target yet.',
      STATUS_PROCESSING: 'Generating',
      STATUS_READY: 'Ready',
      STATUS_FAILED: 'Failed',
      STATUS_STALE: 'Retry needed',
      PREVIEW: 'Preview',
      EMPTY_PREVIEW: 'Select or generate a visual to display the preview.',
      GENERATING: 'Generating visual...',
      GENERATE: 'Generate',
      RETRY: 'Retry',
      DOWNLOAD_PNG: 'Download PNG',
      DOWNLOAD_PDF: 'Download PDF',
      ERROR_REQUIRED_PROMPT: 'Please describe the visual you want.',
      ERROR_MISSING_TARGET: 'Survey target cannot be found.',
      ERROR_UNSUPPORTED_FILE: 'Unsupported format. Use PNG, JPG or WebP.',
      ERROR_QUOTA: 'Insufficient AI credits.',
      ERROR_GENERIC: 'An error occurred while generating the visual.',
    },
    AI_CHAT: {
      BUTTON: 'Chat with Kai',
      TITLE: 'Kai, survey assistant',
      RESPONSES: 'responses',
      QUESTIONS: 'questions',
      HISTORY: 'History',
      NEW_CHAT: 'New chat',
      MINIMIZE: 'Minimize',
      RESTORE: 'Restore chat',
      RUNNING_COMPACT_STATUS: 'Work is continuing in the background...',
      FAILED_COMPACT_STATUS: 'Document analysis needs attention',
      VISUAL_FAILED_COMPACT_STATUS: 'Visual generation needs attention',
      REPORT_FAILED_COMPACT_STATUS: 'Report generation needs attention',
      IDLE_COMPACT_STATUS: 'Chat ready',
      LEAVE_WARNING: 'An operation is still running. Leaving now may interrupt it. Do you want to leave?',
      NEW_CONVERSATION: 'New conversation',
      NO_HISTORY: 'No conversation for this target yet.',
      LOADING: 'Loading...',
      WELCOME_TEXT: 'Hello, I can analyze these results or create a visual from verified survey data.',
      WELCOME_HTML: '<p>Hello, I can analyze these results or create a visual from verified survey data.</p><p><strong>{{responses}}</strong> responses and <strong>{{questions}}</strong> questions are available in the current scope.</p>',
      PLACEHOLDER: 'Ask a question or request a visual...',
      SEND: 'Send',
      FOOTER_HINT: 'Enter to send · Shift+Enter for a line break',
      REFERENCE_IMAGE: 'Reference image',
      REFERENCE_DOCUMENT: 'Reference document',
      ADD_REFERENCE: 'Add a reference image or document',
      PASTE_HINT: 'Ctrl+V to paste an image · PDF and PowerPoint accepted',
      REFERENCE_DEFAULT_PROMPT: 'Use this image as a strict single-page visual template to adapt faithfully, not as optional inspiration. Reproduce its format, aspect ratio, composition, proportions, hierarchy, primary visual mechanism, legend, annotations and color rules. Replace only source content with verified survey data. Do not create additional sections, change the visualization type or transform the layout into a responsive interface.',
      DOCUMENT_REFERENCE_DEFAULT_PROMPT: 'Generate a report from this document.',
      CLEAR_REFERENCE: 'Remove',
      CLEAR_REFERENCE_ERROR: 'Unable to remove the reference image. Please try again.',
      ANALYZING_REFERENCE: 'Analyzing reference...',
      REFERENCE_READY: 'Reference active for this conversation',
      REFERENCE_PAGE_PROGRESS: '{{analyzed}}/{{total}} pages analyzed',
      REFERENCE_AUTOMATIC_RECOVERY: 'Automatically recovering {{count}} page(s) · {{current}}/{{total}}',
      REFERENCE_DOCUMENT_ANALYSIS_TITLE: 'Analyzing the document',
      REFERENCE_IMAGE_ANALYSIS_TITLE: 'Analyzing the image',
      REFERENCE_DOCUMENT_READY_TITLE: 'Document analyzed',
      REFERENCE_IMAGE_READY_TITLE: 'Image analyzed',
      REFERENCE_DOCUMENT_FAILED_TITLE: 'Document analysis incomplete',
      REFERENCE_IMAGE_FAILED_TITLE: 'Image analysis incomplete',
      REFERENCE_IMAGE_TYPE: 'Image',
      REFERENCE_FILE_META_PAGES: '{{type}} · {{pages}} pages',
      REFERENCE_PREPARING_DOCUMENT: 'Preparing the document for analysis',
      REFERENCE_SCANNING_IMAGE: 'Detecting composition, colors and visual regions',
      REFERENCE_ANALYSIS_STEPS: 'Reference analysis steps',
      REFERENCE_STEP_IMPORT: 'Import',
      REFERENCE_STEP_PAGES: 'Pages',
      REFERENCE_STEP_SYNTHESIS: 'Synthesis',
      REFERENCE_STEP_FINALIZATION: 'Finalization',
      REFERENCE_CONTINUES_BACKGROUND: 'Analysis continues in the background if you minimize Kai.',
      REFERENCE_DOCUMENT_READY_DETAIL: 'Reference ready · {{pages}} pages analyzed',
      REFERENCE_IMAGE_READY_DETAIL: 'Composition, colors and visual relationships are ready',
      REFERENCE_ANALYSIS_FAILED: 'Document analysis was interrupted',
      IMAGE_REFERENCE_ANALYSIS_FAILED: 'Image analysis was interrupted',
      RETRY_REFERENCE_ANALYSIS: 'Retry remaining pages',
      CHECK_REFERENCE_ANALYSIS: 'Check analysis status',
      REFERENCE_TRACKING_AUTOMATIC: 'Progress is refreshed automatically.',
      REFERENCE_TRACKING_INTERRUPTED: 'Automatic tracking was interrupted. The analysis may still be running.',
      RESUME_REFERENCE_TRACKING: 'Resume tracking',
      REFERENCE_ANALYSIS_FAILED_DETAIL: 'Pages not analyzed: {{count}}. Successfully analyzed pages are preserved.',
      RETRY_FAILED_REFERENCE_PAGES: 'Retry failed pages ({{count}})',
      RETRY_IMAGE_REFERENCE_ANALYSIS: 'Retry image analysis',
      REPORT_GENERATION_RUNNING: 'Generating report pages...',
      REPORT_CREATION_TITLE: 'Creating your report',
      REPORT_PLANNING_SUBTITLE: 'Organizing sections and pages',
      REPORT_CURRENT_PAGE: 'Generating page {{page}}',
      REPORT_PREPARING_PAGES: 'Preparing report pages',
      REPORT_FINALIZING: 'Finalizing the report',
      REPORT_CONTINUES_BACKGROUND: 'Continues in the background if you minimize this window.',
      REPORT_MINIMIZED_PROGRESS: 'Report · {{ready}}/{{total}} pages · {{percent}}%',
      REPORT_MINIMIZED_PLANNING: 'Report · Planning',
      REPORT_MINIMIZED_RECOVERY: 'Report · Recovering {{count}} page(s)',
      REPORT_RECOVERING_PAGES: 'Pages being recovered: {{count}}',
      REPORT_RECOVERY_CYCLE: 'Automatic recovery {{current}}/{{total}}',
      REPORT_PAGE_STATES: 'Report page states',
      REPORT_PAGE_STATE_READY: 'Page {{page}}, ready',
      REPORT_PAGE_STATE_FAILED: 'Page {{page}}, incomplete',
      REPORT_PAGE_STATE_CURRENT: 'Page {{page}}, generating',
      REPORT_PAGE_STATE_PENDING: 'Page {{page}}, pending',
      REPORT_PHASES: 'Report generation phases',
      REPORT_PHASE_PLANNING: 'Planning',
      REPORT_PHASE_STRUCTURE: 'Structure',
      REPORT_PHASE_PAGES: 'Pages',
      REPORT_PHASE_FINALIZATION: 'Finalization',
      VISUAL_GENERATION_RUNNING: 'Creating your visual',
      VISUAL_CREATION_RUNNING: 'Creating your visual',
      VISUAL_OPTIMIZATION_RUNNING: 'Optimizing your visual',
      VISUAL_PROGRESS_CANDIDATE: 'Version {{current}} of {{total}}',
      VISUAL_PROGRESS_ADJUSTMENT: 'Adjustment {{current}} of {{total}}',
      VISUAL_PROGRESS_STEPS: 'Visual creation steps',
      VISUAL_STEP_ANALYSIS: 'Analysis',
      VISUAL_STEP_CREATION: 'Creation',
      VISUAL_STEP_VALIDATION: 'Verification',
      VISUAL_STEP_FINALIZATION: 'Finalization',
      VISUAL_CONTINUES_BACKGROUND: 'Continues in the background if you close this window.',
      VISUAL_PROGRESS_QUEUED: 'Queued',
      VISUAL_PROGRESS_PREPARING_EVIDENCE: 'Preparing survey evidence',
      VISUAL_PROGRESS_PLANNING_VISUAL: 'Planning the composition',
      VISUAL_PROGRESS_GENERATING_CANDIDATE: 'Building the composition',
      VISUAL_PROGRESS_VALIDATING_CANDIDATE: 'Checking data and layout',
      VISUAL_PROGRESS_CORRECTING_CANDIDATE: 'Refining the composition',
      VISUAL_PROGRESS_FINAL_BROWSER_VALIDATION: 'Reviewing the final canvas',
      VISUAL_PROGRESS_RENDERING_PNG: 'Rendering the image',
      VISUAL_PROGRESS_EXTRACTING_SCENE: 'Preparing editable elements',
      VISUAL_PROGRESS_SAVING_RESULT: 'Saving the result',
      REPORT_PLANNING: 'Preparing the report plan...',
      REPORT_LIVE_FAILED_PAGE_COUNT: 'Pages currently requiring another attempt: {{count}}',
      REPORT_GENERATION_PARTIAL: 'The report is incomplete. Validated pages were kept.',
      REPORT_PAGE_PROGRESS: '{{ready}}/{{total}} pages ready',
      REPORT_FAILED_PAGE_COUNT: 'Pages requiring another attempt: {{count}}',
      RETRY_FAILED_REPORT_PAGES: 'Retry incomplete pages',
      RETRY_VISUAL_GENERATION: 'Retry visual generation',
      VISUAL_PREVIEW: 'Visual preview',
      EXPAND_PREVIEW: 'Expand',
      EXPORT_PNG: 'Export PNG',
      EXPORT_PPTX: 'PowerPoint',
      EXPORT_REPORT_PPTX: 'Export whole report to PowerPoint',
      EXPORT_PDF: 'Export PDF',
      EXPORTING: 'Exporting...',
      OPEN_PNG: 'Open PNG',
      OPEN_PDF: 'Open PDF',
      ERROR_LOAD_HISTORY: 'Unable to load history.',
      ERROR_CREATE_CONVERSATION: 'Unable to create the conversation.',
      ERROR_LOAD_MESSAGES: 'Unable to load messages.',
      ERROR_UNSUPPORTED_IMAGE: 'Unsupported format. Use PNG, JPG or WebP.',
      ERROR_UNSUPPORTED_REFERENCE: 'Unsupported format. Use PNG, JPG, WebP, PDF or PPTX.',
      ERROR_IMAGE_TOO_LARGE: 'The image exceeds the 5 MB size limit.',
      ERROR_DOCUMENT_TOO_LARGE: 'The document exceeds the 20 MB size limit.',
      ERROR_ANALYZE_IMAGE: 'Unable to analyze the reference image.',
      ERROR_ANALYZE_REFERENCE: 'Unable to analyze the reference file.',
      ERROR_DOCUMENT_ANALYSIS_IN_PROGRESS: 'Another document is already being analyzed. Restore the current minimized Kai analysis and wait for it to finish.',
      ERROR_DOCUMENT_ANALYSIS_PARTIAL: 'Document analysis was interrupted. Successful pages were kept; retry to analyze only the remaining pages.',
      ERROR_QUOTA: 'Insufficient AI credits.',
      ERROR_REPORT_GENERATION: 'The report could not be generated. No report was saved and no AI credits were charged.',
      ERROR_VISUAL_GENERATION: 'The visual could not be generated. No visual was saved and no AI credits were charged.',
      ERROR_SEND: 'Unable to send the message.',
      ERROR_EXPORT: 'Unable to export the visual.',
      ERROR_REPORT_EXPORT: 'Unable to export the whole report to PowerPoint.',
      ERROR_REPORT_EXPORT_TOO_LARGE: 'The report is too large to export to PowerPoint.',
      ERROR_REPORT_EXPORT_BUSY: 'PowerPoint export is busy. Please try again shortly.',
      ERROR_REPORT_EXPORT_REGENERATE: 'Regenerate the report visuals before exporting the PowerPoint.',
      ERROR_PPTX_REGENERATE: 'Regenerate this visual before exporting it to PowerPoint.',
      ERROR_PPTX_TOO_LARGE: 'This visual is too large to export to PowerPoint.',
      ERROR_PPTX_BUSY: 'PowerPoint export is busy. Please try again shortly.',
      DELETE_HISTORY_TITLE: 'Delete this conversation?',
      DELETE_HISTORY_WARNING: 'This permanently deletes the conversation, all its messages and visuals, and every associated exported file. This action cannot be undone.',
      DELETE_HISTORY_SUCCESS: 'The conversation and its files were deleted.',
      DELETE_HISTORY_ERROR: 'Unable to delete the conversation and its files.',
    },
  },
}
